/**
 *  Available text filters
 *
 */
export type RdsTextParameter = 'matches' | 'like' | '=' | '!=';

export function invertTextOperation(parameter: RdsTextParameter): RdsTextParameter {
  switch (parameter) {
    case '=':
      return '!=';
    case '!=':
      return '=';
  }
}

export class RdsTextParameterOption {
  constructor(public label: string, public type: RdsTextParameter) {}
}

export const RDS_TEXT_PARAMETER_OPTIONS: ReadonlyArray<RdsTextParameterOption> = Object.freeze([
  // new RdsTextParameterOption('matches', 'matches'),
  // new RdsTextParameterOption('contains', 'like'),
  new RdsTextParameterOption('equals', '='),
  new RdsTextParameterOption('does not equal', '!='),
]);

/**
 * RDS Text Filter
 */
export class RdsTextFilter {
  /**
   * Creates an instance of RdsTextFilter
   * @param text text input
   * @param parameter RdsTextParameterOption
   */
  constructor(public text: string, public parameter: RdsTextParameterOption) {}
}

export function instanceOfRdsTextFilter(obj: any): obj is RdsTextFilter {
  return 'text' in obj && 'parameter' in obj;
}
